import { Content } from '@prismicio/client';
import { Query } from '@prismicio/types';
import { QueryClient, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { decamelizeKeys } from 'humps';

import QueryKeys from 'queries/QueryKeys';
import { apiService } from 'services';
import { PromotionsParams } from 'types/promotion.types';

const getPromotions = async ({
  locale,
  ...params
}: PromotionsParams & { locale?: string }) => {
  const { data } = await apiService.getPromotions({ ...params, locale });

  // decamilze keys so the prismic slicezone can work properly
  return decamelizeKeys(data) as unknown as Query<Content.PromotionsDocument>;
};

export const prefetchPromotions = (
  queryClient: QueryClient,
  params: PromotionsParams,
  locale?: string,
) =>
  queryClient.prefetchQuery({
    queryKey: QueryKeys.promotions.all(params),
    queryFn: () => getPromotions({ ...params, locale }),
  });

export const usePromotions = (
  params: PromotionsParams,
  options?: UseQueryOptions<Query<Content.PromotionsDocument>>,
) => {
  const { data, isLoading } = useQuery({
    queryKey: QueryKeys.promotions.all(params),
    queryFn: () => getPromotions(params),
    ...options,
  });

  return {
    data: data?.results ?? [],
    isLoading,
  };
};
